import React from 'react';

/**
 * `List` renders a simple titled list with optional item icons.
 *
 * Rendering rules:
 * - Always renders `list.title`.
 * - Renders each item as a paragraph.
 * - Renders an `<img>` only when `item.icon` is a non-empty string.
 * - Uses the provided `id` to build stable React keys.
 */

import { TitledList } from './CommonTypes';

export type ListProps = {
  id: string;
  list: TitledList;
};

export const List = ({ id, list }: ListProps): JSX.Element => {
  return (
    <>
      <p className='p1-bold m05-bottom cms'>{list.title}</p>
      {list.items.map((item, i) => (
        <p key={`${id}-${i}`} className='p3 m15-bottom cms'>
          {item.icon && (
            <img
              className='icon-style m1-right'
              src={item.icon}
              alt={`icon-${i}`}
            />
          )}
          <span>{item.text}</span>
        </p>
      ))}
    </>
  );
};

export default List;
